export default __webpack_public_path__ + "static/media/gray-community.df06d95a.png";